import React, {useEffect, useState} from "react";
import {getFirestore} from "firebase/firestore";
import {
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import {getStorage, ref, getDownloadURL, listAll} from "firebase/storage";
import Papa from "papaparse";
import {Autocomplete, TextField, Button} from "@mui/material";
import {useSnackbar} from "notistack";
import {useUser} from "../UserContext.js";
import {useAdmin} from "../admin/AdminContext.js";
import {useTrader} from "../trader/TraderContext.js";
import "./../Styles.css";
import Countdown from "./Countdown.js";

function AddRequest() {
  const {appUser} = useUser();
  const {locates} = useAdmin();
  const {requests, allowedNo20PercentLimit, isOpen, isHoliday} = useTrader();
  const [available, setAvailable] = useState(0);
  const [total, setTotal] = useState(0);
  const [rate, setRate] = useState(0);
  const {enqueueSnackbar} = useSnackbar();
  const [yourAllowed, setYourAllowed] = useState(0);
  const [requestedAmount, setRequestedAmount] = useState(0);
  const [symbol, setSymbol] = useState("");
  const [symbols, setSymbols] = useState([]);
  const [areaText, setAreaText] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    async function getSymbols() {
      let labels = [];
      locates.forEach((l, index) => labels.push({label: l.id.replace(/_/g, '/'), id: index}));
      setSymbols(labels);
      console.log(labels);
    }
    if (locates && locates.length > 0 && isOpen && !isHoliday) {getSymbols();}
  }, [locates, isOpen, isHoliday]);

  const handleChange = (event, value) => {
    if (value === null) {
      setAvailable(0);
      setTotal(0);
      setYourAllowed(0);
      setSymbol("");
      return;
    }
    setAvailable(0);
    setTotal(0);
    setSymbol({label: value.label, id: value.id});
  };

  useEffect(() => {
    async function getAvailable() {
      const myDoc = locates.find((d) => d.id === symbol.label.replace(/\//g, '_'));
      if (myDoc) {
        setAvailable(myDoc.available);
        setTotal(myDoc.total);
        setRate(myDoc.rate);
      } else {
        enqueueSnackbar(`No document for ${symbol.label} found`, {
          variant: "warning",
        });
      }
    }
    if (symbol && symbol.label !== "") {
      getAvailable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbol, locates]);

  useEffect(() => {
    if (appUser?.account !== "" && available !== 0) {
      amIAllowed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [available, symbol, allowedNo20PercentLimit]);

  function trySetRequestedAmount(e) {
    if (e >= 0 && e <= yourAllowed) {
      setRequestedAmount(isNaN(parseInt(e, 10)) ? 0 : parseInt(e, 10));
    } else {
      setRequestedAmount(0);
      enqueueSnackbar(
        `You can't request more than your allowed: ${yourAllowed}`,
        {variant: "warning"},
      );
    }
  }

  const downloadCSV = async () => {
    const storage = getStorage();
    const listRef = ref(storage, 'etb/'); // Reference to your 'etb' bucket
    let fileName = "";
    const res = await listAll(listRef)
    // Process the list of files and find the latest file
    fileName = res.items[0];
    if (fileName.name) {
      const storageRef = ref(storage, `etb/${fileName.name}`);

      try {
        const url = await getDownloadURL(storageRef);
        const response = await fetch(url);
        const data = await response.text();
        return data;
      } catch (error) {
        enqueueSnackbar("Error downloading CSV file: " + error, {variant: "error"});
      }
    } else {
      enqueueSnackbar("No file found ETB csv", {variant: "warning"});
    }
  }

  const parseCSV = (csvText) => {
    return new Promise((resolve) => {
      let processedData = [];
      // Papa.parse(csvText, {
      //   header: true,
      //   complete: (results) => {
      //     resolve(results.data);
      //   }
      // });
      Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true,
        step: function (row) {
          const data = row.data;
          // Check if all fields are present (not undefined or null)
          // Adjust the condition based on how you define a "full" line
          let isFull = true;
          for (let key in data) {
            if (data[key] === undefined || data[key] === null || data[key] === '') {
              isFull = false;
              break;
            }
          }

          if (isFull) {
            processedData.push(data);
          }
        },
        complete: function () {
          resolve(processedData);
        }
      });
    });
  }

  const [etbData, setEtbData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const csvText = await downloadCSV();
      const parsedData = await parseCSV(csvText);
      parsedData.forEach((item) => {
        item.Symbol = item.Symbol.replace(/p/g, '$')/*.replace(/\//g, '_')*/;
      });
      setEtbData(parsedData);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function postRequest(e) {
    e.preventDefault();
    if (symbol === "" || requestedAmount <= 0) return;
    setLoading(true);
    const iAmAllowed = amIAllowed();
    if (requestedAmount > 0 && requestedAmount <= yourAllowed && (iAmAllowed || allowedNo20PercentLimit)) {
      const db = getFirestore();
      const collectionRef = collection(db, "requests");
      try {
        await addDoc(collectionRef, {
          account: appUser.account,
          symbol: symbol.label.replace(/\//g, '_'),
          amount: requestedAmount,
          created: serverTimestamp(),
          createdBy: appUser?.id,
          submitted: null,
          submittedBy: null,
        });
        setSymbol("");
        enqueueSnackbar(`Request for ${requestedAmount} ${symbol.label} added`, {
          variant: "success",
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      const loc = locates.find((l) => l.id === symbol.label);
      const allowed = Math.round(loc.total * 0.2);
      iAmAllowed ?
        enqueueSnackbar(
          `Request amount shall less or equal to ${yourAllowed}`,
          {variant: "warning"},
        ) :
        enqueueSnackbar(
          `Exceeding your quota of ${allowed} for ${symbol.label}!`,
          {variant: "warning"}
        )
    }
    setLoading(false);
  }

  function onChange(e) {
    setAreaText(e.target.value);
  }

  const [enteredRequests, setEnteredRequests] = useState([]);
  function getLines() {
    let tmp = [];
    const lines = areaText.split("\n");
    if (lines.length === 0) {
      if (areaText !== "") {
        lines.push(areaText);
      }
    }
    lines.forEach((line) => {
      const parts = line.split(",");
      if (parts.length === 2) {
        const orderedSymbol = parts[0].trim().toUpperCase().replace(/\//g, '_');
        const orderedAmount = parts[1].trim();
        if (orderedSymbol !== "" && orderedAmount !== "") {
          const found = locates.find((req) => req.id === orderedSymbol);
          if (found) {
            const iAmAllowed = amIAllowed(orderedSymbol, orderedAmount);
            const allowed = Math.round(found.total * 0.2);
            if (orderedAmount > 0 && orderedAmount <= found.available && (iAmAllowed || allowedNo20PercentLimit)) {
              const duplicates = tmp.filter((r) => r.symbol === orderedSymbol);
              if (orderedAmount <= allowed && duplicates.length === 0) {
                tmp.push({symbol: orderedSymbol, amount: orderedAmount});
              } else {
                enqueueSnackbar(
                  `You request twice or higher than allowed amount: ${allowed} for ${orderedSymbol}!`,
                  {variant: "warning"},
                );
              }
            } else {
              enqueueSnackbar(
                `Exceeding your quota of ${allowed} for ${orderedSymbol}!`,
                {variant: "warning"}
              )
            }
          } else {
            enqueueSnackbar(
              `You can't request ${orderedSymbol}!\nCorrect the symbol and try again.`,
              {variant: "warning"},
            );
          }
        }
      }
    });
    setEnteredRequests(tmp);
  }

  function amIAllowed(ordSymbol, ordAmount) {
    const orderedSymbol = ordSymbol ? ordSymbol : symbol.label;
    if (!orderedSymbol) return false;
    const orderedAmount = ordAmount ? ordAmount : requestedAmount;
    const symbolReqs = requests.filter((r) => r.symbol === orderedSymbol.replace(/\//g, '_'));
    const totalAmountPerSymbolPerAccount = symbolReqs.reduce((a, b) => Number(a) + Number(b.amount), 0);
    const found = locates.find((r) => r.id === orderedSymbol.replace(/\//g, '_'));
    const total = found.total;
    const twentyPercent = Math.round(total * 0.2);
    if ((totalAmountPerSymbolPerAccount + Number(orderedAmount) <= twentyPercent)) {
      setYourAllowed(twentyPercent - totalAmountPerSymbolPerAccount);
      return true
    } else if (allowedNo20PercentLimit && (orderedAmount <= available)) {
      setYourAllowed(available);
      return true;
    } else if (totalAmountPerSymbolPerAccount + Number(orderedAmount) >= twentyPercent) {
      if (totalAmountPerSymbolPerAccount >= twentyPercent) {
        setYourAllowed(0);
      } else {
        setYourAllowed(twentyPercent - totalAmountPerSymbolPerAccount);
      }
      return false;
    }
  }

  function sendRequests() {
    setSending(true);
    const db = getFirestore();
    const collectionRef = collection(db, "requests");
    enteredRequests.forEach(async (r) => {
      try {
        await addDoc(collectionRef, {
          account: appUser.account,
          symbol: r.symbol.replace(/\//g, '_'),
          amount: r.amount,
          created: serverTimestamp(),
          createdBy: appUser?.id,
          submitted: null,
          submittedBy: null,
          rejected: null,
          rejectedBy: null,
        });
        enqueueSnackbar(`Request for ${r.amount} ${r.symbol} added`, {
          variant: "success",
        });
      }
      catch (error) {
        enqueueSnackbar(`Request for ${r.amount} ${r.symbol} failed`, {
          variant: "error",
        });
      }
    });
    setEnteredRequests([]);
    setAreaText("");
    setSending(false);
  }

  const [sending, setSending] = useState(false);

  return (
    <>
      {isOpen && !isHoliday ?
        <>
          <div className="allocate-container">
            <div className="allocate-partial-container">
              <h5>Single request</h5>
              <Autocomplete
                sx={{width: "85%"}}
                id="my-input"
                options={symbols}
                value={symbol}
                onChange={handleChange}
                renderInput={(params) => (
                  <TextField {...params} label="Select an option" variant="outlined" />
                )}
                getOptionLabel={(option) => option.label ? option.label : ""}
                isOptionEqualToValue={(option, value) => value.label === option.label || value === ""}
                openOnFocus
                limitTags={4} />
              <label className='amount-for-allocation'>
                Quota &#60;= {yourAllowed} (of {total}); Rate: {rate}
              </label>
              <input
                className='login-text-input'
                name='symbol-text'
                type='text'
                placeholder='Enter Amount'
                onChange={(e) => trySetRequestedAmount(e.target.value)}
                value={requestedAmount} />
              <Button
                className="login-button left-locates"
                onClick={postRequest}
                disabled={loading}>
                {loading ? "Requesting..." : "Request Allocation"}
              </Button>
            </div>
            <div className="allocate-partial-container">
              <h5>Batch requests</h5>
              <div className="container-locates">
                <TextField
                  className="left-locates"
                  placeholder={`ABC, 1000
DEF, 2000
GHI, 3000`}
                  id="textareaAutosize"
                  label="Paste"
                  multiline
                  cols={20}
                  value={areaText}
                  onChange={(onChange)}
                  maxRows={30} />
                <div className="centered-locates" />
                <TextField
                  className="right-locates"
                  placeholder="Press Verify"
                  id="textField"
                  label="Accepted"
                  multiline
                  cols={20}
                  value={enteredRequests.map((r) => r.symbol + "," + r.amount).join("\n")}
                  contentEditable={false}
                  maxRows={30} />
              </div>
              <div className="container-locates">
                <Button
                  className="login-button left-locates"
                  onClick={getLines}>Verify
                </Button>
                <div className="centered-locates" />
                <Button
                  className="login-button left-locates"
                  onClick={sendRequests} disabled={sending}>{sending ? "Requesting..." : "Request Allocations"}
                </Button>
              </div>
            </div>
          </div>
          {requests && requests.length > 0 &&
            <div className={'table-container'}>
              <table>
                <thead>
                  <tr key={"headers"}>
                    <th key={"symbol"}>Symbol</th>
                    <th key={"locates"}>Locates</th>
                    <th key={"status"}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((req, index) => (
                    <>
                      {!req.submitted && !req.rejected &&
                        <tr key={"waiting" + index}>
                          <td key={req.uid + "_1"}>{req.symbol}</td>
                          <td key={req.uid + "_2"}>{req.granted ? req.granted : req.amount}</td>
                          <td key={req.uid + "_3"}>{req.granted ? "Less/Waiting" : "Waiting"}</td>
                        </tr>}
                      {(req.submitted && !req.rejected) &&
                        <tr key={"submitted" + index}>
                          <td key={req.uid + "_1"}>{req.symbol}</td>
                          <td key={req.uid + "_2"}>{req.granted ? req.granted : req.amount}</td>
                          <td key={req.uid + "_3"}>Submitted</td>
                        </tr>}
                      {req.rejected &&
                        <tr key={"rejected" + index}>
                          <td key={req.uid + "_1"}>{req.symbol}</td>
                          <td key={req.uid + "_2"}>{req.amount}</td>
                          <td key={req.uid + "_3"}>Rejected</td>
                        </tr>}
                    </>
                  ))}
                </tbody>
              </table>
            </div>}
          <div className="allocate-partial-container">
            <div className="allocate-container">
              <TextField type="search"
                placeholder="Type to search ..."
                value={searchValue}
                onReset={() => setSearchValue("")}
                onChange={(e) => setSearchValue(e.target.value)}
                min-width="200px"
              />
            </div>
            <div className="allocate-container">
              <div className="allocate-partial-container">
                <h5>HTB Indicative Rates</h5>
                <div className={'table-container'}>
                  <table>
                    <thead>
                      <tr key={"headers"}>
                        <th key={"symbols"}>Symbol</th>
                        <th key={"rates"}>Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {locates.filter((item) => searchValue ? item.symbol.toLocaleLowerCase().startsWith(searchValue.toLocaleLowerCase()) : true).map((locate, index) => (
                        <>
                          <tr key={"symbol" + index}>
                            <td key={locate.symbol}>{locate.symbol}</td>
                            <td key={locate.rate}>{locate.rate}</td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="allocate-partial-container">
                <h5>ETB Indicative Rates</h5>
                <div className={'table-container'}>
                  <table>
                    <thead>
                      <tr>
                        <th>Symbol</th>
                        <th>Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {etbData.filter((item) => searchValue ? item.Symbol.toLocaleLowerCase().startsWith(searchValue.toLocaleLowerCase()) : true).map((item, index) => (
                        <tr key={index}>
                          <td>{item.Symbol}</td>
                          <td>{item.IndicativeRate}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
        :
        <Countdown />
      }
    </>
  );
}
export default AddRequest;
